import { useState, useEffect, useCallback } from "react";
import useCarouselApi from "./useCarouselApi";
const useCarouselActions = (carouselId) => {
  const carouselApi = useCarouselApi(carouselId);
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const onSelect = useCallback(() => {
    setPrevBtnDisabled(!carouselApi.canScrollPrev());
    setNextBtnDisabled(!carouselApi.canScrollNext());
  }, [carouselApi]);
  useEffect(() => {
    if (!carouselApi) return;
    onSelect();
    carouselApi.on("reInit", onSelect);
    carouselApi.on("select", onSelect);
  }, [carouselApi, onSelect]);
  return {
    prevBtnDisabled,
    nextBtnDisabled,
    scrollNext: (carouselApi == null ? void 0 : carouselApi.scrollNext) ? carouselApi.scrollNext : () => {
    },
    scrollPrev: (carouselApi == null ? void 0 : carouselApi.scrollPrev) ? carouselApi.scrollPrev : () => {
    }
  };
};
export default useCarouselActions;
